module.exports = __webpack_public_path__ + "static/face_02-4f8d775e94934ac1929df8001dc2584c.jpg";